<template>
  <b-badge :variant="getPkgType(pkgStatus, payStatus)">
    {{getPkgStatusName(pkgStatus, payStatus)}}
  </b-badge>
</template>

<script>
export default {
  props: ['pkgStatus', 'payStatus'],
  data () {
    return {}
  },
  methods: {
    getPkgType (pkgStatus, payStatus) {
      if ([8,9].indexOf(pkgStatus) > -1) return 'status-parcel-danger'
      if (payStatus === 1) return 'status-parcel-warning'
      if ([5,7,12,1].indexOf(pkgStatus) > -1) return 'status-parcel-success'
      return 'status-parcel-warning'
    },
    getPkgStatusName (pkgStatus, payStatus) {
      if (pkgStatus === 0) return 'รอจัดสรร（เรียกเข้ารับแล้ว）'
      // 异常关闭
      if (pkgStatus === 8) return 'ปิดงานผิดปกติ'
      // 快递已揽件
      if (pkgStatus === 1) return 'ขนส่งเข้ารับแล้ว'
      // 待支付
      if (payStatus === 1) return 'รอชำระ'
      // 待打印
      if (payStatus === 2 && pkgStatus === 11) return 'รอพิมพ์'
      // 待揽件
      if (pkgStatus === 12) return 'รับพัสดุแล้ว'
      // 运输中
      if ([2, 3].indexOf(pkgStatus) > -1) return 'ระหว่างขนส่ง'
      // 已签收
      if (pkgStatus === 5) return 'เซ็นรับแล้ว'
      if (pkgStatus === 6) return 'พัสดุติดปัญหา'
      // 已退回
      if (pkgStatus === 7) return 'ตีกลับแล้ว'
      if (pkgStatus === 9) return 'เรียกคืนแล้ว'
    }
  }
}
</script>

<style>

</style>
